import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visado-landing',
  templateUrl: './visado-landing.component.html',
  styleUrls: ['./visado-landing.component.css']
})
export class VisadoLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToCalendly() {
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02')
  }

  goToWebapp(){
    window.open('https://app.voyjaleas.com/#/sub-app/health-helper');
  }

}
